import { Grid, GridColumn as Column, GridColumnMenuProps, GridColumnMenuCheckboxFilter, GridColumnMenuFilter, GridSelectionChangeEvent, GridCellProps, GridHeaderSelectionChangeEvent, GridPageChangeEvent, GridToolbar, GridColumn, GridFilterChangeEvent, GridColumnResizeEvent, GridColumnReorderEvent, GridDataStateChangeEvent, cellOperatorChange, cellInputChange } from '@progress/kendo-react-grid';
import axios from 'axios';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocalization } from '@progress/kendo-react-intl';
import { Popup } from '@progress/kendo-react-popup';
import { Dialog } from "@progress/kendo-react-dialogs";

import { AccessToken } from '../config/AccessToken';
import { useNavigate } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { HeaderThElement, PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { fileCsvIcon, fileExcelIcon, filePdfIcon, filterIcon, saveIcon, uploadIcon } from '@progress/kendo-svg-icons';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { GridPDFExport } from '@progress/kendo-react-pdf';

import { process as kendoProcess } from "@progress/kendo-data-query";
import { CSVLink } from 'react-csv';
import { json2csv } from 'json-2-csv';
import { SvgIcon } from '@progress/kendo-react-common';
import { Window } from "@progress/kendo-react-dialogs";
import { loadingPanel } from '../components/LoadingPanel';
import { ConfiguratorToggleColumnsGrid } from '../components/ConfiguratorToggleColumnsGrid';
import { DatePicker, TimePicker } from '@progress/kendo-react-dateinputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';


interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };


const LinkMapCell = (props: any) => {

  const localizationService = useLocalization();
  const navigate = useNavigate()

  const mapId = props?.dataItem?.mapId
  const longitude = props?.dataItem?.info?.position?.longitude
  const latitude = props?.dataItem?.info?.position?.latitude
  const elevation = props?.dataItem?.info?.position?.elevation
  
  const showMapFromSelectedAlarm = () => {
    let alarmInfoSelected = props?.dataItem;
    localStorage.setItem("alarmInfoSelected", JSON.stringify(alarmInfoSelected));    
    navigate("/home/map")
  }

  return(    
      <td className="k-command-cell">
        <button
          id="map"
          className="k-icon k-font-icon k-i-globe alarm-globe"
          style={{
            color: '#198792',
            margin: '8px',
            border: 'none',
            background: 'none',
            outline: 'none',
            cursor: mapId == null || (longitude == 0 && latitude == 0 && elevation == 0) ? 'not-allowed' : 'pointer',
            opacity: mapId == null || (longitude == 0 && latitude == 0 && elevation == 0) ? 0.5 : 1,
          }}
          title={ (mapId == null || (longitude == 0 && latitude == 0 && elevation == 0)) ?
            localizationService.toLanguageString('alarms.no_position_found', 'NOT_FOUND')                          
            :
            localizationService.toLanguageString('alarms.map', 'NOT_FOUND')}
          disabled={(mapId == null || (longitude == 0 && latitude == 0 && elevation == 0))}
          onClick={showMapFromSelectedAlarm}
        />
      </td>
  )
}

/**
 * Component to manage and display alarms in a grid format.
 * 
 * This component fetches and displays a list of alarms, allowing the user to
 * filter, sort, and paginate through the alarms. It also provides functionality
 * for exporting the data to Excel, CSV, and PDF formats, as well as saving and
 * loading the grid state configuration.
 * 
 * Methods:
 *  - getAlarmList: Fetches the list of alarms from the server.
 *  - pageChange: Handles page change events.
 *  - onSelectedItemsChange: Handles changes in selected items.
 *  - onHeaderSelection: Handles header selection changes.
 *  - ColumnMenuCheckboxFilter: Renders column menu with checkbox filters.
 *  - getInfoTagAlarm, toggleAlarm: Renders custom cell content for grid.
 *  - InfoPopupRender: Renders popup content for alarm info.
 *  - disableAlarm: Disables selected alarms.
 *  - saveStateToLocalStorage, loadStateFromLocalStorage: Save/load grid state.
 *  - setWidth: Calculates column widths.
 *  - excelExport, pdfExport: Handles data export to Excel and PDF.
 *  - onSearchChange: Handles changes in the search input.
 *  - onFilterChange: Handles filter change events.
 *  - onColumnReorder, onColumnResize: Handles column reorder/resize events.
 *  - onDataStateChange: Handles data state changes for paging and filtering.
**/

export const Alarms = (props?: any) => {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  const [alarms, setAlarms] = useState<any>([]);
  const [alarmInfo, setAlarmInfo] = useState<any>([]);
  const [error, setError] = useState('');
  const [rowSelected, setRowSelected] = useState<any>([]);
  
  const [selectedState, setSelectedState] = useState<{ [id: string]: boolean | number[] }>({});

  const [pageIndex, setPageIndex] = useState<any>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = useState()

  const [disableAllAlarms, setDisableAllAlarms] = useState(false);

  const [columns, setColumns] = useState<any>([]);  

  const [filterName, setFilterName] = useState<any>(() => {
      const filterNameSynoptic = localStorage.getItem('filterNameSynoptic');
      return filterNameSynoptic ? JSON.parse(filterNameSynoptic) : [];
    });

  const [showPopupInfo, setShowPopupInfo] = useState(false);
  
  const [loading, setLoading] = useState(false);

  const DATA_ITEM_KEY: string = 'id';

  const localizationService = useLocalization();

  const [instance, accessTokenRequest] = AccessToken();

  const userEmail = localStorage.getItem('email');

  const languageId = localStorage.getItem('languageId');

  const ColumnMenuCheckboxFilter = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuCheckboxFilter {...props} data={alarms} expanded={true} searchBoxFilterOperator={'contains'}/>
      </div>
    );
  }

  const removeFilterByField = (filterObject: any, fieldName: any): any => {
    if (!filterObject || !filterObject.filters || !Array.isArray(filterObject.filters)) {
      return { logic: 'and', filters: [] };
    }
    
    const updatedFilters = filterObject.filters
    .map((item: any) => {
      // Se è il filtro da rimuovere
      if (item.field === fieldName) {
        return null;
            }
            
            // Se è un gruppo di filtri annidato
            if (item.filters && Array.isArray(item.filters)) {
              const updatedGroup = removeFilterByField(item, fieldName);
                // Mantieni solo se il gruppo ha ancora filtri
                if (updatedGroup.filters.length > 0) {
                    return updatedGroup;
                  } else {
                    return null;
                  }
                }
            return item;
        })
        .filter((item: any) => item !== null);

        // Sempre restituire un oggetto con 'logic' e 'filters'
        return {
          logic: filterObject.logic || 'and',
          filters: updatedFilters
    };
  };

  const GridColumnMenuFilterCell = (props:any) => {

    const gridColumnMenuFilterCell = useRef<any>(null);
   
    const handleResetClick = () => {
      const field = props.field;
  
      // Rimuove il filtro solo per la colonna corrente
      const currentFilter = dataState.filter;
      if (!currentFilter || !Array.isArray(currentFilter.filters)) return;
  
      // Applichiamo la rimozione ricorsiva
      const updatedFilterObject = removeFilterByField(currentFilter, field);

      const newState = {
        ...dataState,
        filter: {
          logic: 'and',
          filters: updatedFilterObject.filters
        }
      };
  
      setDataState(newState);      
      setFilterName((prev: any[]) => {
        const updated = prev?.filter((item) => item !== field) ?? [];
        localStorage.setItem('filterNameAlarm', JSON.stringify(updated));
        return updated;
      });
      
      localStorage.setItem(`gridAlarmState: ${userEmail}`, JSON.stringify({ dataState: newState, columns }));
      localStorage.removeItem('filterOpenedColumn');
    };

    useEffect(() => {
      localStorage.setItem('filterOpenedColumn', 'openedColumn');
    }, []);

    const [selectedOperator, setSelectedOperator] = useState(props.operator || 'eq');    

    const containsDateTimeField = (filters:any):boolean => {
      if (!Array.isArray(filters)) return false;
  
      return filters.some((filter:any) => {
          if (filter.field === 'dateTime') {
              return true;
          } 
          // Se ha sotto-filtri, ricorsivamente cerca anche lì
          if (Array.isArray(filter.filters)) {
              return containsDateTimeField(filter.filters);
          }
          return false;
      });
    };

    const [tempDateTime, setTempDateTime] = useState<Date | any>(null);

    const handleTempDateTimeChange = (value: Date | null) => {
      setTempDateTime(value);
    };
   
    const operatorChange = (event:any) => {
      const newOperator = event.value.operator;
      setSelectedOperator(newOperator); // <-- Track selected operator
      cellOperatorChange(event, props.value, props.onChange);
    };
  
    const renderOperatorEditor = () => {
      const { operators } = props;

      const filteredOperators = operators.filter(
        (op: any) => op.operator !== 'isnull' && op.operator !== 'isnotnull'
      );
  
      const value = filteredOperators.find((item: any) => item.operator === selectedOperator) || null;
  
      return (
        <DropDownList
          value={value}
          onChange={operatorChange}
          data={filteredOperators}
          textField="text"
        />
      );
    };

    useEffect(() => {
      if (!tempDateTime) return;

      // Serve solo a far vedere a Kendo che c'è un valore
      props.onChange?.({
        field: props.field,
        operator: selectedOperator,
        value: new Date(tempDateTime.setMilliseconds(0))
      });
    }, [tempDateTime]);


    useEffect(() => {
      if (props.value && !tempDateTime) {
        setTempDateTime(new Date(props.value));
      }
    }, [props.value]);


    const applyDateTimeFilter = () => {
      if (!tempDateTime) return;

      const cleanDate = new Date(tempDateTime);
      cleanDate.setMilliseconds(0);

      const newFilter = {
        field: props.field,
        operator: selectedOperator,
        value: cleanDate,
      };

      const existingFilters = dataState?.filter?.filters || [];

      const updatedFilters = existingFilters.filter((f: any) => {
        if (f.filters) {
          return !f.filters.some((inner: any) => inner.field === props.field);
        }
        return f.field !== props.field;
      });

      updatedFilters.push({
        logic: 'or',
        filters: [newFilter],
      });

      const newState = {
        ...dataState,
        filter: {
          logic: 'and',
          filters: updatedFilters,
        },
      };

      setDataState(newState);

      props.onChange?.({
        field: props.field,
        operator: selectedOperator,
        value: cleanDate,
      });

      let filterName: any = []
      updatedFilters?.forEach((filter: any) => {
        filter?.filters?.forEach((filterInfo: any) => {
          filterName.push(filterInfo.field)
        })
      })

      setFilterName(filterName)

      localStorage.setItem('filterNameAlarm', JSON.stringify(filterName));
      localStorage.setItem(`gridAlarmState: ${userEmail}`, JSON.stringify({ dataState: newState, columns }));
      localStorage.removeItem('filterOpenedColumn');

      getAlarmList();
    };

    useEffect(() => {
      const handleDocumentClick = (e: MouseEvent) => {
        const resetButton = (e.target as HTMLElement).closest('button[type="reset"]');
        const applyButton = (e.target as HTMLElement).closest('button.k-button');

        const resetText = resetButton?.textContent?.trim();
        const applyText = applyButton?.textContent?.trim();

        if (resetText === 'Ripulisci' || resetText === 'Clear') {
          handleResetClick();
        } else if (applyText === 'Filtro' || applyText === 'Filter') {
          applyDateTimeFilter();
        }
      };

      document.body.addEventListener('click', handleDocumentClick);
      return () => document.body.removeEventListener('click', handleDocumentClick);
    }, [tempDateTime, selectedOperator]);

    return (
      <div 
        ref={gridColumnMenuFilterCell}  
        tabIndex={-1}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        style={{ zIndex: 10000, position: 'relative' }}
      >
        {renderOperatorEditor()}

        <DatePicker
          value={tempDateTime}
          format={languageId === 'en-US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy'}
          formatPlaceholder="formatPattern"
          onChange={(e) => handleTempDateTimeChange(e.value)}
        />

        <div style={{marginBottom: '10px'}}></div>

        <TimePicker
          value={tempDateTime}
          format={languageId === 'en-US' ? 'hh:mm:ss a' : 'HH:mm:ss'}
          formatPlaceholder="formatPattern"
          onChange={(e) => handleTempDateTimeChange(e.value)}
        />

      </div>
    );
  };

  const CustomGridFilterDateTime = (props:any) => {
    const {
      firstFilterProps
    } = props;

     
    return (
      <div>
        <GridColumnMenuFilterCell           
          {...firstFilterProps} 
        />
      </div>
    );
  };

  const InfoTagAlarmComponent = (props: any) => {
    const tagInfo = props.dataItem.info
    return (
      <td
        className="k-icon k-font-icon k-i-information"
        style={{ zoom: '1.5', cursor: 'pointer' }}
        onClick={() => {
          setAlarmInfo(tagInfo);
          setShowPopupInfo(true);
        }
        }
      >
      </td>
    )
  };

  const currColumns: any = [
    { field: 'deviceMac', title: localizationService.toLanguageString('alarms.deviceMac', 'NOT_FOUND'), columnMenu: ColumnMenuCheckboxFilter, minWidth: 100, width: props.preview ? '' : 250, filterable: false, show: true },
    { field: 'name', title: localizationService.toLanguageString('alarms.name', 'NOT_FOUND'), columnMenu: ColumnMenuCheckboxFilter, minWidth: 160, width: props.preview ? '' : 200, filterable: false, show: true },
    { field: 'zoneName', title: localizationService.toLanguageString('alarms.zoneName', 'NOT_FOUND'), columnMenu: ColumnMenuCheckboxFilter, minWidth: 160, width: props.preview ? '' : 200, filterable: false, show: true },
    { field: 'dateTime', title: localizationService.toLanguageString('alarms.dateTime', 'NOT_FOUND'), minWidth: 160, width: props.preview ? '' : 300, editable: false, filter: 'date', format: '{0:dd/MM/yyyy HH:mm:ss}', show: true },
    { field: 'eventType.eventTypeName', title: localizationService.toLanguageString('alarms.eventType.eventTypeName', 'NOT_FOUND'), columnMenu: ColumnMenuCheckboxFilter, minWidth: props.preview ? 200 : 160, width: props.preview ? '' : 300, filterable: false, editable: false, show: true },
    { field: 'eventType.eventTypeDescription', title: localizationService.toLanguageString('alarms.eventType.eventTypeDescription', 'NOT_FOUND'), columnMenu: ColumnMenuCheckboxFilter, minWidth: props.preview ? 450 : 400, width: 300, filterable: false, editable: false, show: true },
    { field: 'info', title: localizationService.toLanguageString('alarms.info', 'NOT_FOUND'), minWidth: 80, width: props.preview ? 0 : 80, cell: !props.preview ? InfoTagAlarmComponent : undefined, filterable: false, editable: false, show: props.preview ? false : true},
    { field: 'groupName', title: localizationService.toLanguageString('alarms.groupName', 'NOT_FOUND'), minWidth: 160, width: props.preview ? '0px' : 200, columnMenu: props.preview ? '' : ColumnMenuCheckboxFilter, filterable: false, editable: false, show: true }
  ];

  const deviceMacFromSynopticInAlarm = localStorage.getItem('deviceMacFromSynopticInAlarm');

  useEffect(() => {
    if(deviceMacFromSynopticInAlarm != null){      
      const filterName:any=['deviceMac']
      
      localStorage.setItem("filterNameAlarm", JSON.stringify(filterName));

      const initialFilter = {
        logic: "and",
        filters: [
          {
            logic: "or",
            filters: [
              {
                field: "deviceMac",
                operator: "eq",
                value: deviceMacFromSynopticInAlarm,
              }
            ]
          }
        ]
      };

      setDataState((prev: any) => ({
        ...prev,
        filter: initialFilter,
      }));

      const updatedState = {
        dataState: {
            ...dataState,
            filter: initialFilter,
            skip: 0,
            take: 10
        },
        columns: currColumns
      };

      localStorage.setItem(`gridAlarmState: ${userEmail}`, JSON.stringify(updatedState));

      getAlarmListByDeviceMac(deviceMacFromSynopticInAlarm)      
    }else{
      getAlarmList()
    }
  }, [])

  const getAlarmList = async (removedDeviceMacFromSynopticInAlarm?: any) => {

    setLoading(true);

    if (removedDeviceMacFromSynopticInAlarm) {      
      
      const current = JSON.parse(localStorage.getItem('filterNameAlarm') || '[]');
      const updated = current.filter((item: any) => item !== 'deviceMac');
      localStorage.setItem('filterNameAlarm', JSON.stringify(updated));

      setDataState((prev: any) => {
        const currentFilter = prev.filter;

        if (!currentFilter || !Array.isArray(currentFilter.filters)) return prev;

        const newFilters = currentFilter.filters
          .map((group: any) => {
            if (group.logic === 'or' && Array.isArray(group.filters)) {
              // rimuove solo 'deviceMac' da OR
              const newSubFilters = group.filters.filter((f: any) => f.field !== 'deviceMac');
              return newSubFilters.length > 0 ? { ...group, filters: newSubFilters } : null;
            }
            // rimuove se è un filtro diretto su deviceMac
            return group.field === 'deviceMac' ? null : group;
          })
          .filter(Boolean);

        const newFilter = {
          ...currentFilter,
          filters: newFilters
        };

        const updatedState = {
          ...prev,
          filter: newFilter
        };

        // aggiorna anche localStorage
        localStorage.setItem(`gridAlarmState: ${userEmail}`, JSON.stringify({
          dataState: {
            ...prev,
            filter: newFilter,
            skip: prev.skip ?? 0,
            take: prev.take ?? 10
          },
          columns: currColumns
        }));

        return updatedState;
      });
      
    }


    let languageId = localStorage.getItem('languageId');

    const commonOperations = (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      
      axios.get(`${SERVER_URL}/alarm/list`, { headers})
        .then((res:any) => { 
          
          const data = res?.data?.data

          const alarmsInfo:any = []

          // format date in data.data
          data?.forEach((alarm: any) => {
            if (alarm.dateTime == null) {
              alarm.dateTime = localizationService.toLanguageString('alarms.date_not_found', 'NOT_FOUND')
              return
            }
            alarm.dateTime = convertDateTime(alarm?.dateTime)

            alarmsInfo.push(alarm)
          })

          setAlarms(alarmsInfo)
          
          loadStateFromLocalStorage();
          
          setLoading(false);

        }).catch((data) => {
          //setError(data?.message);
          setLoading(false);
        });
    }

    if (localStorage.getItem('accessToken') != null) {
      let accessToken = localStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
    }
  }

  const getAlarmListByDeviceMac = async (deviceMac:any, skip?: any, take?: any) => {

    setLoading(true);

    let languageId = localStorage.getItem('languageId');

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      
      await axios.get(`${SERVER_URL}/alarm/ListAlarmsByMac?mac=${deviceMac}`, { headers })
        .then((res:any) => {
          
          const data = res?.data?.data
          if(data?.length == 0){
            setLoading(false);
            return
          } 

          // format date in data.data
          data?.forEach((alarm: any) => {
            if (alarm.dateTime == null) {
              alarm.dateTime = localizationService.toLanguageString('alarms.date_not_found', 'NOT_FOUND')
              return
            }
            alarm.dateTime = alarm?.dateTime?.split('T')[0]

            //format alarm.dateTime with gg/mm/yyyy
            var dateParts = alarm.dateTime.split("/");

            var yearFormatted:any = dateParts[2].split(' ')[0]

            const day = dateParts[0] //date?.getDay();
            const month = dateParts[1] //(date.getMonth() + 1).toString().padStart(2, "0");
            const year = yearFormatted;
            alarm.dateTime = new Date(`${year}, ${month},${day}`)
          })
          
          setAlarms(data)

          loadStateFromLocalStorage();
                    
          setLoading(false);          

        }).catch((data) => {
          setError(data?.message);
          setLoading(false);
        });
    }

    if (localStorage.getItem('accessToken') != null) {
      let accessToken = localStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
    }
  }
    
  const exportRecords = async (format:any) => {

    setLoading(true);

    let languageId = localStorage.getItem('languageId');

    const commonOperations = (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      
      axios.get(`${SERVER_URL}/alarm/download?format=${format}`, { headers, responseType: 'blob' })
        .then((response) => {

          const type:any = format == 'csv' ? 'text/csv;charset=utf-8;' : format == 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf'
          
          const ext:any = format == 'csv' ? '.csv' : format == 'excel' ? '.xlsx' : '.pdf'

          const blob = new Blob([response.data], { type: type });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.setAttribute("href", url);
          link.setAttribute("download", `records${ext}`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          setLoading(false);

        }).catch((error) => {
          if (error.response) {
            setError(error.response.data.message);
          } else {
            setError(error.message);
          }
          setLoading(false);
        });
    }

    if (localStorage.getItem('accessToken') != null) {
      let accessToken = localStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
    }
  }

  const onPageChange = (event: any) => {
    const targetEvent = event.targetEvent;
    const newSkip = event?.page?.skip;
    const newTake = event?.targetEvent?.value === 'All' ? alarms?.length : event.page.take;
    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setDataState((prevState: any) => ({
      ...prevState,
      skip: newSkip,
      take: newTake
    }));
    // Salva lo stato aggiornato completo nel localStorage
    const updatedState = {
        dataState: {
            ...dataState,
            skip: newSkip,
            take: newTake
        },
        columns
    };
    localStorage.setItem(`gridAlarmState: ${userEmail}`, JSON.stringify(updatedState));
  };

  // used for checkbox selection
  const onSelectedItemsChange = useCallback((event: GridSelectionChangeEvent) => {
    setRowSelected(event?.dataItems?.map((item: any) => item.id) || [])

    if (event?.syntheticEvent?.currentTarget?.checked) {
      props.handlePopupAlarm()
    }
  },
    [selectedState]
  );

  const onHeaderSelection = useCallback((event: GridHeaderSelectionChangeEvent) => {

    const newSelectedState: any = [];

    let data: any = event.dataItems ?? event

    data?.data?.forEach((item: any) => {
      newSelectedState.push(item.id)
    });
    setSelectedState(newSelectedState);
    setRowSelected(newSelectedState)
    props.handlePopupAlarm()
  },
    []
  );
  
  const toggleAlarm = (propsGrid: GridCellProps) => {

    return (
      <td className="k-command-cell" style={{textAlign: 'center'}}>
        <button
          id='disabled-alarm'
          className="k-icon k-font-icon k-i-bell"
          style={{ color: '#198792', margin: '8px', border: 'none', background: 'none', outline: 'none' }}
          onClick={() => 
            {
              setRowSelected(propsGrid.dataItem.id)
              setDisableAllAlarms(false)
              props.handlePopupAlarm()
            }
          }
        >
          <a  id='disabled-alarm' />
        </button>
      </td>    
    )
  };

  const disableAlarm = async () => {

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}` };
      const params = {
        accountId: -1,
        alarmIds: Array.isArray(rowSelected) ? rowSelected : [rowSelected],
      };
      try {
        await axios.post(`${SERVER_URL}/alarm/ackalarm`, params, { headers })
        props.handlePopupAlarm()
        getAlarmList()
        loadStateFromLocalStorage();
      } catch (error: any) {
        setError(error);
      }
    }

    if (localStorage.getItem('accessToken') != null) {
      let accessToken = localStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken)
      })
    }
  }

  const [dataState, setDataState] = useState<any>({
    skip: 0,
    take: pageIndex?.take ?? 10,
    data: alarms,
    total: alarms?.length,
    filter: { logic: 'and', filters: [] },
    //sort: [{ field: 'mac', dir: 'desc' }]
  });

  const saveStateToLocalStorage = () => {
    const state: any = { dataState, columns };
    localStorage.setItem(`gridAlarmState: ${userEmail}`, JSON.stringify(state));
  };

  const loadStateFromLocalStorage = () => {
    const storedFilter = localStorage.getItem(`gridAlarmState: ${userEmail}`);
    if (storedFilter) {
      const { dataState: savedDataState, columns: savedColumns } = JSON.parse(storedFilter);

      savedColumns.forEach((column: any) => {
        column.title = localizationService.toLanguageString(`alarms.${column.field}`, 'NOT_FOUND');
      })

      if (savedDataState?.filter != null) {
        // Funzione ricorsiva per gestire qualsiasi struttura di filtri
        const updateFilterValues = (filter: any): any => {
          if (Array.isArray(filter.filters)) {
            return {
              ...filter,
              filters: filter.filters.map(updateFilterValues),
            };
          } else {
            const field = filter?.field;
            let value = filter?.value;
  
            if (['dateTime'].includes(field)) {
              value = new Date(value);
            }
  
            return {
              ...filter,
              value,
            };
          }
        };
  
        const updatedFilter = updateFilterValues(savedDataState.filter);
  
        const updatedSavedDataState = {
          ...savedDataState,
          filter: updatedFilter,
        };
  
        setDataState(updatedSavedDataState);
      } else {
        setDataState(savedDataState);
      }

      const currentColumn:any = savedColumns?.map((column: any, id: any) => {
        if(column.id == id){
          return { ...column, show: !column.show }; // Create a *new* object
        }
        return column; // Return the other columns unchanged
      });

      setColumns(currentColumn);

      return storedFilter
        ? storedFilter
        : currentColumn;
    }else{
      setColumns(currColumns)
    }
    setLoading(false);          
  };

  const anchor = useRef<any>(null);
  const [showPopupSaveConfig, setShowPopupSaveConfig] = useState(false);

  const onClickSaveConfig = () => {
    setShowPopupSaveConfig(!showPopupSaveConfig);

    setTimeout(() => {
      setShowPopupSaveConfig(showPopupSaveConfig);
    }, 3000)

  };

  
  const CellRender = (props: any) => {
    return (
      <td
          {...props.tdProps}
          colSpan={1}
      >
          {props.children}
      </td>
    );
  }

  const onFilterChange = (event: GridFilterChangeEvent) => {
    const newFilter: any = event.filter
      ? { ...event.filter }
      : { logic: 'and', filters: [] };

    setDataState((prevState: any) => ({
      ...prevState,
      filter: newFilter
    }));

    let filterName:any=[]
    newFilter?.filters?.forEach((filter:any) => {
      filter?.filters?.forEach((filterInfo:any) => {
        filterName.push(filterInfo.field)
      })
    })
    localStorage.setItem("filterNameAlarm", JSON.stringify(filterName));
  };

  const anchorSave = useRef<any>(null);

  const onChange = (event: any) => {
    const field = event.target.name;
    const newColumns = columns.map((column: any) => {
      if (column.field === field) {
        return { ...column, show: !column.show };
      }
      return column;
    });
    setColumns(newColumns);
    
    const state = { dataState, columns: newColumns };
    localStorage.setItem(`gridAlarmState: ${userEmail}`, JSON.stringify(state));
  };

  const onColumnReorder = (event: GridColumnReorderEvent) => {
    setColumns(event.columns);
    saveStateToLocalStorage();
  };

  const onColumnResize = (event: GridColumnResizeEvent) => {
    setColumns(event.columns);
    saveStateToLocalStorage();
  };

  const sanitizeFilter = (filter: any) => {
    if (filter && typeof filter === 'object' && Array.isArray(filter.filters)) {
      const flatFilters = filter.filters.flatMap((f: any) =>
        Array.isArray(f.filters) ? f.filters : [f]
      );
  
      return {
        logic: filter.logic || 'and',
        filters: flatFilters
      };
    }
    return { logic: 'and', filters: [] };
  };

  const safeFilter = sanitizeFilter(dataState?.filter);
  const processedData:any = kendoProcess(alarms, {
    filter: dataState?.filter ?? safeFilter, 
    sort: dataState?.sort,
    skip: dataState?.skip,
    take: dataState?.take,
  });
  
  const onDataStateChange = (event: any) => {
    
    const newFilter: any = event.dataState.filter
      ? { ...event.dataState.filter }
      : { logic: 'and', filters: [] };

    let filterName:any=[]
    newFilter?.filters?.forEach((filter:any) => {
      filter?.filters?.forEach((filterInfo:any) => {
        filterName.push(filterInfo.field)
      })
    })
    setFilterName(filterName)
    localStorage.setItem("filterNameAlarm", JSON.stringify(filterName));

    const { dataState } = event;
    if (dataState) {
      const { filter, sort, skip, take } = dataState;
      const updatedFilter = filter || dataState.filter;
      const updatedSkip = skip !== undefined ? skip : dataState.skip;
      const updatedTake = take !== undefined ? take : dataState.take;
      setDataState((prevState: any) => ({
        ...prevState,
        filter: updatedFilter,
        sort: sort,
        skip: updatedSkip,
        take: updatedTake
      }));      
    }
    const state = { dataState, columns };
    localStorage.setItem(`gridAlarmState: ${userEmail}`, JSON.stringify(state));
  };

  const formatDateFromIsoToString = (date:any) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    if (languageId == 'en-US') {
      hours = hours % 12;
      hours = hours === 0 ? 12 : hours; // convert 0 → 12
      const hours12 = String(hours).padStart(2, '0');
      return `${month}/${day}/${year} ${hours12}:${minutes}:${seconds}`;
    } else {
      const hours24 = String(hours).padStart(2, '0');
      return `${day}/${month}/${year} ${hours24}:${minutes}:${seconds}`;
    }
  }

  const convertDateTime = (dateTime:any) => {
  
    const [datePart, timePart] = dateTime.split(' ');
    const [day, month, year] = datePart.split('/');
    const [hour, minute, seconds] = timePart.split(':');

    const date = new Date(Date.UTC(year, month-1, day, hour, minute, seconds))

    return date
  }
  
  const DateTimeCellWithBackGroundComponent = (props: any) => {
    const date = new Date(props?.dataItem?.dateTime);
    const meridian = date.toLocaleString('en-US', { hour: 'numeric', hour12: true }).split(' ')[1];
    const dateTimeValue:any = formatDateFromIsoToString(props.dataItem.dateTime);  
    if(dateTimeValue != null && !dateTimeValue.includes('1970')){   
      return(
        <td>
          <span style={{display: 'block', width: '200px'}}>
            {dateTimeValue} { languageId === 'it-IT' ? '' : meridian}
          </span>
        </td>
      )
    } else {
      return(
        <td><span/></td>
      )
    }
  };

  const IconHeaderCell = (props: any) => {      
    localStorage.removeItem('filterOpenedColumn');
    const savedFilterName:any = localStorage.getItem('filterNameAlarm');
    
    return savedFilterName?.includes(props.field) ?       
      <HeaderThElement columnId={props.thProps?.columnId || ''} {...props.thProps} >
        <span style={{display:'inline-flex'}}>{props.children} <SvgIcon icon={filterIcon} size="medium"/></span>
      </HeaderThElement>    
    :
      <HeaderThElement columnId={props.thProps?.columnId || ''} {...props.thProps} >
        {props.children}
      </HeaderThElement>
  };


  return (
    <div 
      style={{ 
        position: 'relative',
        display: 'grid',
        width: '98%',   
        overflowY: 'auto',  
        margin: '10px',        
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 15px 5px'        
      }}
    >
      {error && <p className="text-danger" style={{ zIndex: 999, position: 'relative', width: '65%' }}>{error}</p>}
      {/*{alarms == null && loadingPanel}*/}
      {loading && loadingPanel}
        
        <ExcelExport data={processedData} >
          <Grid
            data={processedData}
            dataItemKey={'id'}
            cells={{ data: CellRender}}
            //total={totalItems}
            sortable={true}
            reorderable={false}
            take={dataState?.take ?? 10}
            skip={dataState?.skip ?? 0}
            pageable={{
              type: 'input',
              buttonCount: 5,
              pageSizes: [5, 10, 50, 100, 'All'],
              pageSizeValue: pageSizeValue,
              info: true
            }}
            sort={dataState.sort}
            filter={dataState.filter}
            onSelectionChange={onSelectedItemsChange}
            onHeaderSelectionChange={onHeaderSelection}
            onPageChange={onPageChange}
            onColumnReorder={onColumnReorder}
            onColumnResize={onColumnResize}
            onDataStateChange={onDataStateChange}
            scrollable={'none'}
          >
            <GridToolbar>
              <div>
                <h3>{localizationService.toLanguageString('alarms.title', 'NOT_FOUND')}</h3>
              </div>
              {!props.preview ?
                <div style={{alignItems: 'baseline'}}>
                  <button
                    className='alarm-page disable-alarm-button'
                    onClick={() => {
                      onHeaderSelection(processedData);
                      setDisableAllAlarms(true)
                    }}
                  >
                    {localizationService.toLanguageString('alarms.disable_all_alarms_button', 'NOT_FOUND')}
                  </button>
                  { deviceMacFromSynopticInAlarm ?
                    <div 
                      style={{
                        color: '#1A8894',
                        float: 'right',
                        margin: '8px auto'
                      }}
                    >
                      <div style={{background: '#CED4DA', display: 'flex', height: '30px', alignItems: 'anchor-center', borderRadius: '5px'}}>
                        <p style={{fontSize: '14px', fontWeight:'bolder', marginBottom: '0px', marginLeft: '10px'}}>Mac:</p>
                        <p style={{
                            marginLeft: '10px',
                            fontSize: '14px',
                            alignContent: 'center',
                            marginBottom: '0px',
                            marginRight: '10px',
                          }}
                        >
                          {deviceMacFromSynopticInAlarm}
                        </p>
                        <Button 
                          className='alarmsFilterByMac'
                          onClick={(e:any)=>{
                            e.stopPropagation()
                            localStorage.removeItem('deviceMacFromSynopticInAlarm');
                            getAlarmList(true);
                          }}
                        >X</Button>
                      </div>
                    </div>
                    : null
                  }
                </div>
                : null}
                <Popup
                  anchor={anchor.current && anchor.current.element}
                  show={showPopupSaveConfig}
                  popupClass={"popup-content-save-synoptic-config"}
                >
                  {localizationService.toLanguageString('synoptic_devices.saved_config', 'NOT_FOUND')}
                </Popup>
              <div style={{ right: '15px', float: 'right', position: 'absolute', display: 'flex', gap: '8px' }}>
                <ConfiguratorToggleColumnsGrid columns={columns} onChange={onChange} />
                
                <div>
                  <Button
                    themeColor={"primary"}
                    size="small"
                    title={localizationService.toLanguageString('export_to_csv', 'NOT_FOUND')}
                    svgIcon={fileCsvIcon}
                    onClick={()=>exportRecords('csv')}
                  />
                </div>
                <div>
                  <Button
                    onClick={()=>exportRecords('pdf')}
                    themeColor={"primary"}
                    size="small"
                    title={localizationService.toLanguageString('export_to_pdf', 'NOT_FOUND')}
                    svgIcon={filePdfIcon}
                  />
                </div>
                <div>
                  <Button
                    title={localizationService.toLanguageString('export_to_excel', 'NOT_FOUND')}
                    themeColor={"primary"}
                    size="small"
                    svgIcon={fileExcelIcon}
                    onClick={()=>exportRecords('excel')}
                  />
                </div>
                {/*{!props.preview ?
                  <div>
                    <Button
                      ref={anchor}
                      title={localizationService.toLanguageString('save_config', 'NOT_FOUND')}
                      themeColor={'primary'}
                      size="small"
                      svgIcon={saveIcon}
                      onClick={() => {
                        saveStateToLocalStorage();
                        onClickSaveConfig()
                      }}
                    >
                    </Button>
                  </div>
                  : null}
                {!props.preview ?
                  <div>
                    <Button
                      themeColor={'primary'}
                      size="small"
                      svgIcon={uploadIcon}
                      onClick={loadStateFromLocalStorage}
                      title={localizationService.toLanguageString('load_config', 'NOT_FOUND')}
                    >
                    </Button>
                  </div>
                  : null}*/}
              </div>
            </GridToolbar>
            {!props.preview ?
              <Column
                cells={{data: (props) => <LinkMapCell {...props} />}}
                width={50}
                editable={false}
                filterable={false}
                sortable={false}
              />              
              : null}
            {!props.preview ?
              <Column
                title={localizationService.toLanguageString('alarms.deactive', 'NOT_FOUND')}
                width={props.preview ? '0px' : 60}
                filterable={false}
                editable={false}
                sortable={false}
                cells={{data:toggleAlarm}}
              />
              : null}
            {
              columns?.length > 0 ?
                columns?.map((column: any, index: any) =>
                  column?.show && (
                    column.field == 'dateTime' ?
                      <Column              
                        field='dateTime'
                        title={localizationService.toLanguageString('alarms.dateTime', 'NOT_FOUND')}
                        editable={false}
                        format={column.format}
                        columnMenu={(props) => (
                          <GridColumnMenuFilter
                            {...props}                        
                            alwaysExpand
                            filterUI={CustomGridFilterDateTime}
                            onExpandChange={() => {}}
                            onCloseMenu={() => { 
                              localStorage.removeItem('filterOpenedColumn');
                            }}
                          />
                        )}
                        filter={'date'}
                        sortable={true}
                        cells={{ 
                          data: (props) => <DateTimeCellWithBackGroundComponent  {...props} />,
                          headerCell:IconHeaderCell
                        }}
                      />
                    :
                    column.field == 'info' ?
                    <Column
                      field={column.field}
                      title={column.title}
                      filterable={column?.filterable}
                      sortable={false}
                      //columnMenu={ColumnMenuCheckboxFilter}
                      className='k-text-center'
                      cells={{ 
                        data: (props) => <InfoTagAlarmComponent  {...props} /> ,
                        headerCell: IconHeaderCell
                      }}
                      filter={column?.filter}
                      format={column?.format}
                      //width={300}
                      editable={false}
                    />
                    :
                    <Column
                      key={index}
                      field={column.field}
                      title={column.title}
                      filterable={column?.filterable}
                      columnMenu={ColumnMenuCheckboxFilter}
                      className='k-text-center'
                      cells={{ headerCell: IconHeaderCell }}
                      filter={column?.filter}
                      format={column?.format}
                      width={'2000'}
                      editable={false}
                    />
                  )
                )
                :
                columns?.columns?.map((column: any, index: any) =>
                  column.show && !props.preview && (
                    <Column
                      field={column.field}
                      title={column.title}
                      filterable={column?.filterable}
                      columnMenu={ColumnMenuCheckboxFilter}
                      className='k-text-center'
                      cells={{ data: (props) => <InfoTagAlarmComponent  {...props} /> }}
                      filter={column?.filter}
                      format={column?.format}
                      editable={false}
                    />
                  )
                )
            }            
            {/* <Column field="Discontinued" filter="boolean" width="180px" />  */}
          </Grid> 
        </ExcelExport>        
          
        <GridPDFExport margin="1cm">
          {
            columns?.length > 0 ?
              columns?.map((column: any, index: any) =>
                column.show && (
                  <Column
                    key={index}
                    field={column.field}
                    title={column.title}
                    filterable={column?.filterable}
                    columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                    className='k-text-center'
                    cells={{ data: (props) => <InfoTagAlarmComponent  {...props} /> }}
                    filter={column?.filter}
                    format={column?.format}
                    editable={column?.editable}
                  />
                )
              )
              :
              columns?.columns?.map((column: any, index: any) =>
                column.show && (
                  <Column
                    key={index}
                    field={column.field}
                    title={column.title}
                    filterable={column?.filterable}
                    columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                    className='k-text-center'
                    cells={{ data: (props) => <InfoTagAlarmComponent  {...props} /> }}
                    filter={column?.filter}
                    format={column?.format}
                    editable={column?.editable}
                  />
                )
              )
          }
          <Grid
            data={processedData}
            dataItemKey={DATA_ITEM_KEY}
            //cellRender={cellRender}
            cells={{ data: CellRender}}
            //total={totalItems}
            take={dataState?.take ?? 10}
            skip={dataState?.skip ?? 0}
            pageable={{
              type: 'input',
              buttonCount: 5,
              pageSizes: [5, 10, 50, 100],
              info: true
            }}
            sortable={true}
            filterable={true}
            //reorderable={false}
            sort={dataState.sort}
            filter={dataState.filter}
            onSelectionChange={onSelectedItemsChange}
            onHeaderSelectionChange={onHeaderSelection}
            onPageChange={onPageChange}
            onFilterChange={onFilterChange}
            onColumnReorder={onColumnReorder}
            onColumnResize={onColumnResize}
            onDataStateChange={onDataStateChange}
            scrollable={'none'}
          >
            <GridToolbar>
              <div>
                <span style={{
                  fontSize: '1.25rem',
                  fontWeight: '400'
                }}
              >{localizationService.toLanguageString('alarms.title', 'NOT_FOUND')}</span>
              </div>
              {!props.preview ?
                <div>
                  <button
                    className='alarm-page disable-alarm-button'
                    onClick={() => {
                      onHeaderSelection(alarms);
                      setDisableAllAlarms(true)
                    }}
                  >
                    {localizationService.toLanguageString('alarms.disable_all_alarms_button', 'NOT_FOUND')}
                  </button>
                </div>
                : null}
                <Popup
                  anchor={anchor.current && anchor.current.element}
                  show={showPopupSaveConfig}
                  popupClass={"popup-content-save-synoptic-config"}
                >
                  {localizationService.toLanguageString('synoptic_devices.saved_config', 'NOT_FOUND')}
                </Popup>
              <div style={{ right: '15px', float: 'right', position: 'absolute', display: 'flex', gap: '8px' }}>
                {!props.preview ?
                  <div>
                    <Button
                      ref={anchorSave}
                      title={localizationService.toLanguageString('save_config', 'NOT_FOUND')}
                      themeColor={'primary'}
                      size="small"
                      svgIcon={saveIcon}
                      onClick={() => {
                        saveStateToLocalStorage();
                        onClickSaveConfig()
                      }}
                    >
                    </Button>
                  </div>
                  : null}
                {!props.preview ?
                  <div>
                    <Button
                      themeColor={'primary'}
                      size="small"
                      svgIcon={uploadIcon}
                      onClick={loadStateFromLocalStorage}
                      title={localizationService.toLanguageString('load_config', 'NOT_FOUND')}
                    >
                    </Button>
                  </div>
                  : null}
                <div>
                  <CSVLink data={json2csv(alarms)} separator={","}>
                    <Button
                      themeColor={"primary"}
                      size="small"
                      title={localizationService.toLanguageString('export_to_csv', 'NOT_FOUND')}
                      svgIcon={fileCsvIcon}
                    />
                  </CSVLink>
                </div>
                <div>
                  <Button
                    onClick={()=>exportRecords('pdf')}
                    themeColor={"primary"}
                    size="small"
                    title={localizationService.toLanguageString('export_to_pdf', 'NOT_FOUND')}
                    svgIcon={filePdfIcon}
                  />
                </div>
                <div>
                  <Button
                    title={localizationService.toLanguageString('export_to_excel', 'NOT_FOUND')}
                    themeColor={"primary"}
                    size="small"
                    svgIcon={fileExcelIcon}
                    onClick={()=>exportRecords('excel')}
                  />
                </div>
                <ConfiguratorToggleColumnsGrid columns={columns} onChange={onChange} />
              </div>
            </GridToolbar>
            {!props.preview ?
              <Column
                cells={{data: (props) => <LinkMapCell {...props} />}}
                width={50}
                editable={false}
                filterable={false}
                sortable={false}
              />   
              : null}
            {!props.preview ?
              <Column
                title={localizationService.toLanguageString('alarms.deactive', 'NOT_FOUND')}
                width={props.preview ? '0px' : 100}
                filterable={false}
                editable={false}
                cells={{data: toggleAlarm}}
              />
              : null}
            {
              columns?.length > 0 ?
                columns?.map((column: any, index: any) =>
                  column.show && (
                    <GridColumn
                      key={index}
                      field={column.field}
                      title={column.title}
                      filterable={column?.filterable}
                      columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                      className='k-text-center'
                      cells={{ data: (props) => <InfoTagAlarmComponent  {...props} /> }}
                      filter={column?.filter}
                      format={column?.format}
                      editable={column?.editable}
                    />
                  )
                )
                :
                columns?.columns?.map((column: any, index: any) =>
                  column.show && (
                    <GridColumn
                      key={index}
                      field={column.field}
                      title={column.title}
                      filterable={column?.filterable}
                      columnMenu={column?.columnMenu ? ColumnMenuCheckboxFilter : undefined}
                      className='k-text-center'
                      cells={{ data: (props) => <InfoTagAlarmComponent  {...props} /> }}
                      filter={column?.filter}
                      format={column?.format}
                      editable={column?.editable}
                    />
                  )
                )
            }
          </Grid>
        </GridPDFExport>
        {showPopupInfo &&
          <Window
            title={localizationService.toLanguageString('alarms.alarm_details', 'NOT_FOUND')}
            onClose={()=> setShowPopupInfo(!showPopupInfo)}
            resizable={false}
            initialWidth={400}
            initialHeight={480}
            style={{
              border: '2px solid white',
              background: '#198792',
              color: 'white',
              boxShadow: '0px 0px 0px 2px #198792'
            }}
          >
            <div>
              <p><span style={{ fontWeight: 'bold' }}>{localizationService.toLanguageString('alarms.title', 'NOT_FOUND')}</span>: {alarmInfo?.deviceType ? alarmInfo?.deviceType : "N/D"}</p>
              <p><span style={{ fontWeight: 'bold' }}>{localizationService.toLanguageString('alarms.firmware', 'NOT_FOUND')}</span>: {alarmInfo?.firmware != null ? alarmInfo?.firmware : "N/D"}</p>
              <p><span style={{ fontWeight: 'bold' }}>{localizationService.toLanguageString('alarms.temperature', 'NOT_FOUND')}</span>: {alarmInfo?.temperature != null ? alarmInfo?.temperature : "N/D"}</p>
              <p><span style={{ fontWeight: 'bold' }}>{localizationService.toLanguageString('alarms.pressure', 'NOT_FOUND')}</span>: {alarmInfo?.pressure ? alarmInfo?.pressure : "N/D"}</p>
              <p><span style={{ fontWeight: 'bold' }}>{localizationService.toLanguageString('alarms.battery', 'NOT_FOUND')}</span>: {alarmInfo?.battery != null ? alarmInfo?.battery : "N/D"}</p>
              <p><span style={{ fontWeight: 'bold' }}>{localizationService.toLanguageString('alarms.wifiap', 'NOT_FOUND')}</span>: {alarmInfo?.visibleWiFiAp ? alarmInfo?.visibleWiFiAp : "N/D"}</p>
              <p><span style={{ fontWeight: 'bold' }}>{localizationService.toLanguageString('alarms.longitude', 'NOT_FOUND')}</span>: {alarmInfo?.position?.longitude != null ? alarmInfo?.position?.longitude : "N/D"}</p>
              <p><span style={{ fontWeight: 'bold' }}>{localizationService.toLanguageString('alarms.latitude', 'NOT_FOUND')}</span>: {alarmInfo?.position?.latitude != null ? alarmInfo?.position?.latitude : "N/D"}</p>
              <p><span style={{ fontWeight: 'bold' }}>{localizationService.toLanguageString('alarms.altitude', 'NOT_FOUND')}</span>: {alarmInfo?.position?.elevation != null ? alarmInfo?.position?.elevation : "N/D"}</p>
            </div>
          </Window>
        }
        {props.showPopupAlarm && (
          <Dialog
            title={disableAllAlarms ? localizationService.toLanguageString('alarms.disable_all_alarms', 'NOT_FOUND') : localizationService.toLanguageString('alarms.disable_alarm', 'NOT_FOUND')}
            onClose={props.handlePopupAlarm}
          >
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              style={{
                margin: '10px',
                width: '80px'
              }}
              onClick={props.handlePopupAlarm}
            >
              No
            </button>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              style={{
                margin: '10px',
                width: '80px'
              }}
              onClick={disableAlarm}
            >
              {localizationService.toLanguageString('alarms.yes', 'NOT_FOUND')}
            </button>
          </Dialog>
        )}
      
    </div>
  );
};